import { DefaultButton, Dialog, DialogFooter, DialogType, Label, PrimaryButton, Stack } from "@fluentui/react"
import { useState } from "react"
import { IEnrollmentRecord } from "../types/IEnrollmentRecord"

interface TerminateDialogProps {
	closePanel: (reload: boolean, success: boolean) => void
	householdMember: IEnrollmentRecord
}

export function TerminateDialog({ closePanel, householdMember }: TerminateDialogProps) {
	const [isTerminating, setIsTerminating] = useState(false)

	return (
		<Dialog
			onDismiss={() => closePanel(false, false)}
			hidden={false}
			dialogContentProps={{
				type: DialogType.normal,
				title: (
					<Stack horizontalAlign="center">
						<h3 style={{ marginTop: 0 }}>Terminate Employee Coverage</h3>
					</Stack>
				)
			}}
			modalProps={{
				isBlocking: true
			}}>
			<Stack tokens={{ childrenGap: 8 }}>
				<div style={{ fontSize: 18, fontWeight: 500 }}>Are you sure you want to terminate the following employee?</div>
				<Stack tokens={{ childrenGap: 8 }}>
					<Stack horizontal tokens={{ childrenGap: 8 }} verticalAlign="center">
						<Label>Name</Label>
						<span>
							{householdMember.firstName} {householdMember.lastName}
						</span>
					</Stack>
					<Stack horizontal tokens={{ childrenGap: 8 }} verticalAlign="center">
						<Label>Household Members (including employee)</Label>
						<span>TBD</span>
					</Stack>
				</Stack>
			</Stack>
			<DialogFooter>
				<PrimaryButton
					disabled={isTerminating}
					onClick={() => {
						setIsTerminating(true)
						alert("TBD: Terminate Employee")
					}}
					text="Terminate"
				/>
				<DefaultButton onClick={() => closePanel(false, false)} text="Cancel" />
			</DialogFooter>
		</Dialog>
	)
}
